import { redirect } from '@tanstack/react-router'
import { studentDashboardApi } from '@/lib/api/student-dashboard'

export interface StudentProfile {
  id: string
  name: string
  email: string
  image: string | null
  firstName: string | null
  lastName: string | null
  phone: string | null
  birthDate: string | null
  cpfCnpj: string | null
  authorId: string | null
}

export async function requireStudentAuth(): Promise<{ profile: StudentProfile }> {
  try {
    const { data, error } = await studentDashboardApi().api.student.dashboard.profile.get()
    if (error || !data) {
      throw redirect({ to: '/login' })
    }
    const profile = data.data as StudentProfile | null
    if (!profile) throw redirect({ to: '/login' })
    return { profile }
  } catch (e: any) {
    if (!(e instanceof Error)) throw e
    throw redirect({ to: '/login' })
  }
}

export async function requireGuest() {
  try {
    const { data } = await studentDashboardApi().api.student.dashboard.profile.get()
    if (data && data.data) {
      throw redirect({ to: '/' })
    }
  } catch (e: any) {
    if (!(e instanceof Error)) throw e
    // API error on guest page → allow rendering (user not logged in)
  }
}
